import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAccountInfo } from "../../api/accounts";
import type { CurrentAccount } from "../../types/Account";

interface AccountState {
  loading: boolean;
  error: boolean;
  data: CurrentAccount;
}
const initialState: AccountState = {
  loading: false,
  error: false,
  data: {
    id: 0,
    subdomain: "",
    companyLogoUrl: "",
    companyName: "",
    subscriptions: [],
  },
};

export const getCurrentAccountInfo = createAsyncThunk(
  "account/info",
  async (_, arg: any) => {
    const resp = await getAccountInfo();
    return resp.data;
  }
);

const AccountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCurrentAccountInfo.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.data = { ...state.data, ...payload };
    });
    builder.addCase(getCurrentAccountInfo.pending, (state, { payload }) => {
      state.loading = true;
      state.data = initialState.data;
    });
    builder.addCase(getCurrentAccountInfo.rejected, (state, { error }) => {
      state.loading = false;
      state.error = true;
      state.data = initialState.data;
    });
  },
});

export default AccountSlice.reducer;
